import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router'
import tableSettingsFactory from "./table-settings";
import {fetchAttendeeList} from './ducks'
import RegistrationStatus from './RegistrationStatus.js'
import ContactName from './ContactName.js'
import FilterBy from 'template/FilterBy'
import DropdownSelect from 'components/UI/Form/Fields/DropdownSelect';
import Loading from 'components/UI/Loading';
import RegistrationTableFloat from 'template/Floats/RegistrationTableFloat';


import {
	PanelWrapper,
  Table,
} from 'components/UI'

import './RegistrationTable.scss'


const locale = {
  id: 'RegistrationTable',
  code: 'CN',
  text: {
    'Show All': '全部',
    'Poster': '海报',
  }
}

const AMOUNT_PER_PAGE = 25;

const mapStateToProps = (state) => ({
  attendee_list: state.attendeeList,
})

class RegistrationTable extends Component {
  constructor(props){
    super(props)

		this.state = {
			filterData: {},
      currentTypeShown: -1,
      status: 6,
      pagination: {
        activePage: 1,
        itemsCountPerPage: 25,
        totalItemsCount: 0
      },
      posterId: props.params.posterId || null,
      singlePoster: props.params.posterId? true: false,
      keyword: '',
      orderBy: 0
    }

		this.onFilterChange = this.onFilterChange.bind(this)
    this.onSelectChange = this.onSelectChange.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onItemsCountPerPageChange = this.onItemsCountPerPageChange.bind(this)
    this.dropdownOptions = [];
    if(this.state.singlePoster){
      this.filters = ['text:searchKeyword', 'registrationStatus'];

      this.filter_options = {
        'text:searchKeyword': {
          placeholder: __('Search Name, Email, or Phone No.', 'registrationTable'),
          valueMinLength: 2
        },
        registrationStatus: {
          selectMultiple: false,
        }
      }
    }else {
      this.filters = ['text:searchKeyword', 'registrationStatus', 'poster'];

      this.filter_options = {
        'text:searchKeyword': {
          placeholder: __('Search Name, Email, or Phone No.', 'registrationTable'),
          valueMinLength: 2
        },
        registrationStatus: {
          selectMultiple: false,
        },
        poster: {
          selectMultiple: false,
        }
      }
    }
  }

  componentDidMount(){
    const {dispatch} = this.props;
    const {posterId, orderBy} = this.state;
		const schoolId = localStorage.getItem('schoolId');

    dispatch(fetchAttendeeList(schoolId, {
      posterId: posterId,
      state: 6,
      amount_per_page: AMOUNT_PER_PAGE,
      order_by: orderBy,
      page_number: 1
    }))

  }

	componentWillReceiveProps({attendee_list}){
    this.setState((prevState)=>({
      pagination: {...prevState.pagination, totalItemsCount: attendee_list.count}
    }))
    this.originalList = attendee_list.list
    this.list = [ ...this.originalList ];

    this.dropdownOptions = [
      { label: __('Show All', locale), value: -1 }
    ];

    // create dropdown options
    this.labelPerOptionID = {}

    if (this.list) {
			this.list.map((lst) => {
				if (!this.labelPerOptionID[lst.ticket_id]) {
					this.dropdownOptions.push({
						label: lst.ticket_title,
						value: lst.ticket_id,
          })
					this.labelPerOptionID[lst.ticket_id] = lst.ticket_title;
				}
			});
		}
	}

	onFilterChange({ filterData }){
    const {dispatch, params} = this.props
    const {orderBy} = this.state
    const schoolId = localStorage.getItem('schoolId');
    this.setState((prevState)=>({
      pagination: {...prevState.pagination, activePage: 1},
      filterData,
      posterId: filterData.poster? filterData.poster.IDs[0]: params.posterId,
      keyword: filterData['searchKeyword']
    }),()=>{
      dispatch(fetchAttendeeList(schoolId, {
        posterId: this.state.posterId,
        state: filterData.registrationStatus? filterData.registrationStatus.items[0].value : 6 ,
        amount_per_page: this.state.pagination.itemsCountPerPage,
        page_number: this.state.pagination.activePage,
        kw: this.state.keyword,
        order_by: orderBy
      }))
    })

		// this.list = this.props.attendee_list.list
		// this.forceUpdate()

		// let multiple_search = ''
		// if(filterData.multiple_search){
		// 	multiple_search = filterData.multiple_search.toLowerCase()
		// }

		// let newArray = []

		// if(filterData.multiple_search && filterData.multiple_search.trim() != '' ){
		// 	this.list.filter((result) => {
		// 		const {attendee_name = '', contact_email = '', contact_phone = ''} = result
    //     if(attendee_name.toLowerCase().indexOf(multiple_search.toLowerCase()) > -1
    //       || contact_email.toLowerCase().indexOf(multiple_search.toLowerCase()) > -1
    //       || contact_phone.toLowerCase().indexOf(multiple_search.toLowerCase()) > -1){
		// 			newArray.push(result)

		// 		}
    //   })

    //   this.list = [ ...newArray ];
    //   this.forceUpdate()
		// }
	}

	onSelectChange(ticketIDToShow){
    let newArray = [];

    if (ticketIDToShow == -1) {
      this.list = [ ...this.originalList ];

      this.setState({
        currentTypeShown: -1,
      })

      return;
    }

    this.originalList.filter((res) => {
      const {ticket_id} = res
			if(ticket_id == ticketIDToShow){
				newArray.push(res)
			}
    })

    this.list = [ ...newArray ];
    this.setState({
      currentTypeShown: ticketIDToShow,
    })
  }

  onPageChange(pageNum){
    const {dispatch} = this.props
    const {posterId, orderBy} = this.state
    const schoolId = localStorage.getItem('schoolId');
    const { pagination, filterData, keyword } = this.state;

    this.setState((prevState)=>({
      pagination: {...prevState.pagination, activePage: pageNum}
    }),()=>{
      dispatch(fetchAttendeeList(schoolId, {
        posterId: posterId,
        state: filterData.registrationStatus? filterData.registrationStatus.items[0].value : 6 ,
        amount_per_page: pagination.itemsCountPerPage,
        page_number: this.state.pagination.activePage,
        kw: keyword,
        order_by: orderBy
      }))
    })
  }

  onItemsCountPerPageChange(count){
    const {dispatch} = this.props
    const {posterId, filterData, keyword, orderBy} = this.state
    const schoolId = localStorage.getItem('schoolId');

    this.setState((prevState)=>({
      pagination: {...prevState.pagination, itemsCountPerPage: count}
    }),()=>{
      dispatch(fetchAttendeeList(schoolId, {
        posterId: posterId,
        state: filterData.registrationStatus? filterData.registrationStatus.items[0].value : 6,
        amount_per_page: this.state.pagination.itemsCountPerPage,
        page_number: this.state.activePage,
        order_by: orderBy,
        kw: keyword
      }))
    })
  }

  render(){
    const {attendee_list, dispatch} = this.props
    const {posterTitle} = attendee_list
    const {openFloatModal, floatTarget, attendeeInfo, pagination, singlePoster, orderBy, posterId, filterData, keyword, activePage} = this.state;
    
    const fields = [
      {
        name: 'poster_title',
        title: __('Poster Title', 'registrationTable'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "15%"
            }
          }
        }
      },
      {
        name: 'ticket_title',
        title: __('Item', 'registrationTable'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "15%"
            }
          }
        }
      },
      {
        name: 'attendee_name',
        title: __('Applicant', 'registrationTable'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "15%"
            }
          }
        },
				getTdContent: ({ trData: attendeeInfo })=>{
					return <ContactName attendeeInfo={attendeeInfo} />
				},
      },
      {
        name: 'contact_name',
        title: __('Contact Name', 'registrationTable'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "10%"
            }
          }
        },

      },
      {
        name: 'contact_email',
        title: __('Contact Email', 'registrationTable'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "20%"
            }
          }
        }
      },
      {
        name: 'contact_phone',
        title: __('Contact Phone No.', 'registrationTable'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "15%"
            }
          }
        }
      },
      {
        name: 'state',
        title: __('Status', 'registrationTable'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "12%"
            }
          }
        },
        getTdContent: ({ trData: attendeeInfo })=>{
          return <RegistrationStatus attendeeInfo={attendeeInfo} />
        },
      },
    ]

    this.tableSettings = tableSettingsFactory.call(this);
		const schoolId = localStorage.getItem('schoolId')

    return(
      <PanelWrapper className='registration-table-container' >
        {
          singlePoster && 
          <div className='bread-crumbs'>
            <Link to='/poster'><span>{__('Poster', locale)}</span></Link>
            <span> / </span>
            <span>{posterTitle}</span>
          </div>
        }
        {
          !singlePoster && 
          <div>{__('Poster Registration List', 'registrationTable')}</div>
        }
				<Link className='registration-table-close pull-right' to='/poster'>
          <i className='fa icon-cancel'></i>
				</Link>


        <div className='poster-title'>{posterTitle}</div>
        <div className='util-section'>
          <FilterBy
            filterData={this.state.filterData}
            filters={this.filters}
            options={this.filter_options}
            schoolId={schoolId}
            onChange={this.onFilterChange}
          />
          {/* { this.dropdownOptions.length > 0 &&
            <DropdownSelect value={currentTypeShown} noCaret={false} options={this.dropdownOptions} onChange={(id) => {
              this.onSelectChange(id)
            }} />
          } */}
          <div className='sort-by-wrapper'>
            <span>{__('Sort by', 'registrationTable')}</span>
            <select 
              className='form-control sort-by' 
              value={orderBy}
              onChange={(e) => {
                this.setState({orderBy: e.target.value},()=>{
                  dispatch(fetchAttendeeList(schoolId, {
                    posterId: posterId,
                    state: filterData.registrationStatus? filterData.registrationStatus.items[0].value : 6,
                    amount_per_page: pagination.itemsCountPerPage,
                    page_number: activePage,
                    order_by: this.state.orderBy,
                    kw: keyword
                  }))
                })
              }}>
                <option key='0' value='0'>{__('Creation Time: Newest to Oldest', 'registrationTable')}</option>
                <option key='1' value='1'>{__('Creation Time: Oldest to Newest', 'registrationTable')}</option>
            </select>
          </div>

        </div>
        {
          this.props.attendee_list.fetching ? <Loading /> : 
            <Table
            data={this.list}
            fields={fields}
            crqassName='registration-table'
            settingThTitle={__('Settings', 'class', null, true)}
            settingWidth={'150px'}
            settings={this.tableSettings}
            useMultiSelection={false}
            oneSettingPerRow={false}
            dropdownGuideWidth={160}
            dropdownGuideHeight={228}
            pagination={pagination}
            usePagination={true}
            onPageChange={this.onPageChange}
            onItemsCountPerPageChange={this.onItemsCountPerPageChange}
          />
        }

				<RegistrationTableFloat
					attendeeInfo={attendeeInfo}
					show={openFloatModal}
					target={floatTarget}
          onCloseFloat={()=>{ this.setState({ openFloatModal: false }) }}
				/>
      </PanelWrapper>
    )
  }
}


export default connect(mapStateToProps)(RegistrationTable)



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/RegistrationTable/index.js